import { ServiceResponse } from "../../api/ServiceResponse";
import { PumpTransaction } from "./PumpTransaction";

export class PumpTransactionResponse extends ServiceResponse {
  pumpTransactionList?: PumpTransaction[];
  count?: number;

  constructor(init?: Partial<PumpTransactionResponse>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getPumpTransactionList(): PumpTransaction[] | undefined {
    return this.pumpTransactionList;
  }
  setPumpTransactionList(value: PumpTransaction[] | undefined): void {
    this.pumpTransactionList = value;
  }

  getCount(): number | undefined {
    return this.count;
  }
  setCount(value: number | undefined): void {
    this.count = value;
  }
}
